<template>
  <div>
    <div class="container mt-4">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <input type="text" placeholder="Rechercher un dossier" class="form-control" v-model="term" />
          </div>
        </div>
      </div>
      <div class="row" @click="withArchived = !withArchived">
        <div class="col-12 mb-3">
          <div class="form-check text-center">
            <input type="checkbox" class="form-check-input" v-model="withArchived" />
            <label class="form-check-label" for="defaultCheck1">
              Dossiers archivés
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="text-center">
                Dossiers
                <div class="row" v-if="term == '' && dossiersWithoutLinkedDossiers.length">
                  <div class="col-10 offset-1 mb-2 dossiers-with-email text-center">
                    où l'email apparaît
                  </div>
                </div>

              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dossier in dossiersWithoutLinkedDossiers" v-bind:key="dossier.id">
              <td>
                <button class="btn btn-outline-info w-100 text-left" @click="setSelectedDossier(dossier)">
                  {{ dossier.nom + ' [' + dossier.numero + ']' }}
                </button>
              </td>
            </tr>
            <tr v-if="!dossiersWithoutLinkedDossiers || dossiersWithoutLinkedDossiers.length == 0">
              <td class="text-center" v-if="!isQuerying">Aucun résultat</td>
              <td class="text-center" v-if="isQuerying">
                <i class="fas fa-spinner fa-spin"></i>
              </td>
            </tr>
          </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Login from './Login.vue';
import { Dossier } from '../interfaces/interfaces'
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component'
import LysiasApiMixin from '../mixins/LysiasApiMixin'
import debounce from 'debounce-async'


@Component({ components: {
      Login,
    }
})
export default class Search extends mixins(LysiasApiMixin)
{
  private term = "";
  private dossiers: Dossier[] = [];
  private error = "";
  private withArchived = false;
  private isExpeditor = 'true';
  private withEmail: string|null = null;
  private executeSearchDossier = debounce(this._searchDossier, 500);
  private executeFetchDossiersWithEmail = debounce(this._fetchDossiersWithEmail, 500);
  private isQuerying = false;

  mounted()
  {
    this.$store.commit('setLoginFormVisible', false);
    this.$store.commit('setCabinetFormVisible', false);
    this.$store.commit('setCabinetsVisible', false);
    this.sendQuery();
  }

  @Watch('withArchived')
  async withArchivedChanged()
  {
    this.sendQuery();
  }


  @Watch('term')
  async termChanged()
  {
    this.sendQuery();
  }

  @Watch('selectedDossier')
  onNewSelectedDossier()
  {
    this.$router.push({ name: 'arborescence', params: { isLinked: 'false' }});
  }

  get selectedDossier()
  {
    return this.$store.state.currentDossier;
  }

  setSelectedDossier(dossier: Dossier)
  {
    this.$store.commit('setCurrentDossier', dossier);
  }

  async _fetchDossiersWithEmail()
  {
    try
    {
      console.log(this.term);
      this.dossiers = await this.getDossiersWithEmail(this.isExpeditor, this.withEmail, this.withArchived);
    }
    catch(e: any)
    {
      this.error = e.message;
    }

  }

  async _searchDossier()
  {
    try
    {
      console.log(this.term);
      this.dossiers = await this.searchDossier(this.term, this.isExpeditor, this.withEmail, this.withArchived);
    }
    catch(e: any)
    {
      this.error = e.message;
    }

  }

  async sendQuery()
  {
    this.isQuerying = true;
    if(this.term.trim().length == 0)
    {
      const mail = Office.context.mailbox.item;
      const from = mail!.from.emailAddress;
      this.isExpeditor = 'true';
      this.withEmail = from;
    }
    else
    {
      this.withEmail = null;
    }

    try
    {
      if(this.term.trim().length == 0)
      {
        await this.executeFetchDossiersWithEmail();
      }
      else
      {
        await this.executeSearchDossier();
      }
    }
    catch(e: any)
    {
      console.log(e);
    }

    this.isQuerying = false;
  }

  get dossiersWithoutLinkedDossiers()
  {
    const linkedDossiersIds = this.$store.state.linkedDossiers.map((d:Dossier) => d.id);
    return this.dossiers.filter((d:Dossier) => !linkedDossiersIds.includes(d.id));
  }
}
</script>

<style scoped lang="scss">
.dossiers-with-email
{
  font-size: 12px;
  color: gray;
}
</style>
